import React, {useEffect, useState} from 'react'
import {updateStock} from "../../services/serviceStock";
import {AutoComplete, Button, Form, Input, InputNumber, Modal} from "antd";
import StockWarehouseQuantity from "./StockWarehouseQuantity";
import {createAll} from "../../services/serviceInventory";
import config from "../../config";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const {Option} = AutoComplete
const {TextArea} = Input
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}
const currencyOptions = [
    {
        value: 'TRY'
    },
    {
        value: 'USD'
    },
    {
        value: 'EUR'
    },

];

const StockEdit = ({stock, updater, isVisible, modalCloser, stockInventory, brandList, categoryList}) => {
    const [form] = Form.useForm()
    const [createdBrand, setCreatedBrand] = useState()
    const [brands, setBrands] = useState([])
    const [createdCategory, setCreatedCategory] = useState()
    const [categories, setCategories] = useState([])
    const [modalVisible] = useState(isVisible)
    const [bulkInventory, setBulkInventory] = useState([])
    const [loadings, setLoadings] = useState([])

    useEffect(() => {
        form.setFieldsValue({
            stockName: stock.stockName,
            stockCode: stock.stockCode,
            stockDescription: stock.stockDescription,
            stockQuantity: stock.stockQuantity,
            stockUnit: stock.stockUnit,
            stockPrice: stock.stockPrice,
            stockCurrency: stock.stockCurrency,
            stockThreshold: stock.stockThreshold,
            stockFirmCode: stock.stockFirmCode,
            stockBrand: stock.stockBrand,
            stockCategory: stock.stockCategory
        })
        const mockInventory = Object.assign([], stockInventory)
        setCreatedCategory(stock.stockCategoryId)
        setCreatedBrand(stock.stockBrandId)
        setCategories(categoryList)
        setBrands(brandList)
        setBulkInventory(mockInventory)
    }, [stock, stockInventory])

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            id: stock.stockId,
            name: list.stockName,
            code: list.stockCode,
            description: list.stockDescription,
            quantity: list.stockQuantity,
            price: list.stockPrice,
            currency: list.stockCurrency,
            unit: list.stockUnit,
            criticalThresdhold: list.stockThreshold,
            firmStockCode: list.stockFirmCode,
            brandId: createdBrand,
            categoryId: createdCategory
        }

        updateStock(requestObj)
            .then(() => {
                if (bulkInventory.length) {
                    createAll(bulkInventory)
                        .then(() => {
                            exitLoadingState(setLoadings)
                            modalCloser()
                            updater()
                        })
                }
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }
    const handleBrandChange = (value, option) => setCreatedBrand(option.key)
    const handleCategoryChange = (value, option) => setCreatedCategory(option.key)
    const appendBulkWarehouse = (quantity, warehouseId, ...rest) => {
        const mockState = bulkInventory
        const warehouseItem = mockState.find((item) => item.warehouse.id === warehouseId)
        const singleItem = {
            quantity: quantity,
            warehouse: {id: warehouseId},
            stock: {id: stock.stockId}
        }

        if (rest.recordId) {
            singleItem.id = rest.recordId
        }

        if (warehouseItem && !quantity) {
            mockState.splice(mockState.indexOf(warehouseItem), 1)
            setBulkInventory([...mockState])
            return
        }

        if (warehouseItem) {
            warehouseItem.quantity = quantity
            setBulkInventory([...mockState])
            return
        }

        setBulkInventory([...mockState, singleItem])
    }

    return (
        <React.Fragment>
            <Modal
                open={modalVisible}
                closable={false}
                title={`Güncelle`}
                footer={[
                    <Button loading={loadings[0]} type={'primary'} key={'SubmitButton'} onClick={() => form.submit()}>Kaydet</Button>,
                    <Button onClick={modalCloser} key={'CloseButton'}>Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    labelAlign={'left'}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >
                    <Form.Item
                        label={'Stok Cinsi'}
                        name={'stockName'}
                        rules={[
                            {required: true, message: 'Stok Adı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Stok Adı En Az 5 En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Stok Kodu'}
                        name={'stockCode'}
                        rules={[
                            {required: true, message: 'Stok Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Stok Kodu Alanı Boşluk İçeremez'},
                            {min: 0, max: 250, message: 'Stok Kodu En az 0 En Fazla 250 Karakter Olabilir'}
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Firma Stok Kodu'}
                        name={'stockFirmCode'}
                        rules={[
                            {max: 300, message: 'Firma Stok Kodu Alanı En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Stok Açıklaması'}
                        name={'stockDescription'}
                        rules={[
                            {max: 100, message: 'Açıklama Alanı En Fazla 100 Karakter Olabilir'}
                        ]}
                    >
                        <TextArea/>
                    </Form.Item>
                    <Form.Item
                        label={'Marka'}
                        name={'stockBrand'}
                        rules={[
                            {required: true, message: 'Lütfen Bir Marka Seçiniz'}
                        ]}
                    >
                        <AutoComplete
                            onChange={handleBrandChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {brands.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Kategori'}
                        name={'stockCategory'}
                        rules={[
                            {required: true, message: 'Lütfen Bir Kategori Seçiniz'}
                        ]}
                    >
                        <AutoComplete
                            onChange={handleCategoryChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {categories.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Birim'}
                        name={'stockUnit'}
                        rules={[
                            {required: true, message: 'Lütfen Birim Seçiniz'},
                            () => ({
                                validator(rule, value) {
                                    let hasValue = config.stockUnits.filter(unit => unit.value.toLowerCase() === value.toLowerCase())
                                    if (value && hasValue.length > 0) {
                                        return Promise.resolve();
                                    }

                                    return Promise.reject('Lütfen Geçerli Bir Değer Giriniz');
                                },
                            })
                        ]}
                    >
                        <AutoComplete
                            options={config.stockUnits}
                            style={{width: '150px'}}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        />
                    </Form.Item>
                    <Form.Item
                        label={'Fiyat&Para Birimi'}
                    >
                        <Input.Group compact>
                            <Form.Item
                                noStyle
                                name={'stockPrice'}
                                rules={[
                                    {required: true, message: 'Lütfen Fiyat Giriniz'},
                                    {type: 'number', min: 0, message: 'Fiyat Alanı En Az 0 Olmalıdır'}
                                ]}
                            >
                                <InputNumber step={0.1} min={0} style={{width: '50%'}}/>
                            </Form.Item>
                            <Form.Item
                                noStyle
                                name={'stockCurrency'}
                                rules={[
                                    {required: true, message: 'Para Birimi Boş Bırakılamaz'}
                                ]}
                            >
                                <AutoComplete
                                    options={currencyOptions}
                                    style={{width: '100px'}}
                                    filterOption={(inputValue, option) =>
                                        option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                />
                            </Form.Item>
                        </Input.Group>
                    </Form.Item>
                    {
                        stockInventory.map((item, index) => {
                            return <StockWarehouseQuantity key={index} warehouseName={item.warehouse.name}
                                                           warehouseId={item.warehouse.id}
                                                           initialQuantity={item.quantity} recordId={item.id}
                                                           updateBulkList={appendBulkWarehouse}/>
                        })
                    }
                    <Form.Item
                        label={'Alt Limit'}
                        name={'stockThreshold'}
                        rules={[
                            {required: true, message: 'Alt Limit Alanı Boş Bırakılamaz'},
                            {type: 'number', min: 0, message: 'Alt Limit Alanı En Az 0 Olabilir'}
                        ]}
                    >
                        <InputNumber step={0.1}/>
                    </Form.Item>
                </Form>
            </Modal>

        </React.Fragment>
    )
}
export default StockEdit